import { mapRequirements } from "../../../utils/formRequirementsHelper";

export const storeRequirements = (state, { payload }) => {
  const requirements = mapRequirements(payload);
  return {
    ...state,
   ...requirements
  }
}
